import { NATIONALITY_MAP } from '../constants/signup.constants';

export type DocumentoPais = 'chile' | 'venezuela' | 'other';

/**
 * Pais de residencia sugerido a partir del pais que EMITIO el documento.
 *
 * Es solo una sugerencia editable, pensada para que el 90% de los usuarios no
 * tenga que tocar el select. Nunca se deriva de la nacionalidad ni la pisa.
 * Para documentos de otros paises se deja vacio: no se adivina.
 */
export function residenciaSugerida(documentoPais: DocumentoPais): string {
  if (documentoPais === 'chile') return 'Chile';
  if (documentoPais === 'venezuela') return 'Venezuela';
  return '';
}

/**
 * Normaliza la nacionalidad que vino del documento a un nombre de pais de la
 * lista (`COUNTRY_PHONE_OPTIONS`), para que el select la pueda preseleccionar.
 *
 * Si el documento no declara nacionalidad devuelve '' — NUNCA el pais emisor
 * del documento. El campo es requerido en el formulario, asi que un vacio
 * obliga al usuario a declararla en vez de asumirla por el.
 *
 * Si el valor no esta en el mapa se devuelve tal cual vino: preferimos
 * mostrarlo (aunque el select no lo matchee) antes que perder el dato.
 */
export function mapNacionalidad(nacionalidadOcr?: string | null): string {
  const raw = (nacionalidadOcr || '').trim();
  if (!raw) return '';
  return NATIONALITY_MAP[raw.toUpperCase()] || raw;
}
